<template lang="pug">
v-dialog(
  scrollable lazy
  v-model='dialog'
  :persistent='isModified'
  :max-width='dialogMaxWidth'
  :fullscreen='isFullscreen'
  :transition='transition'
)
  v-card(@keyup.esc='close')
    //- 對話框標題列
    v-toolbar(color='primary' dark style={zIndex: 10000})
      v-btn(icon dark @click='close' :disabled='isLoading'): v-icon close
      v-toolbar-title 編輯抽獎 #[ModifiedDot(:show='isModified && !isLoading')]
      v-spacer

      v-toolbar-items
         v-btn(flat @click='save' v-if='lottery && !lottery.winner' :loading='isLoading' :disabled='!valid')
          | {{ $t('saveAndPublish') }}

      v-menu(bottom right offset-y :disabled='isLoading' v-if='id')
        v-btn(slot='activator' icon): v-icon more_vert
        v-list
          v-list-tile(@click='removeWinner' v-if='isDebugMode')
            v-list-tile-action: v-icon fas fa-user-minus
            v-list-tile-title 清空得獎者
          v-list-tile(@click='remove' color='error')
            v-list-tile-action: v-icon(color='error') fas fa-trash-alt
            v-list-tile-title 移除抽獎活動

    //- 錯誤提示訊息
    v-alert(type='error' :value='true' v-if='lottery === false' icon='warning') {{ $t('errorWhileLoading') }} {{ error }}
    v-alert(type='error' :value='true' v-else-if='isSaveFailed && error' icon='warning') {{ $t('failedToSave') }} {{ error.response }}

    //- 表單
    v-card-text(v-if='lottery')
      v-alert.mb-3(:value='lottery.winner' type='info' color='grey') 此抽獎活動為唯獨狀態，因為已抽出得獎者
      v-form(ref='form' v-model='valid')
        v-container.pa-0
          v-layout(row wrap)
            v-flex(xs12 md6)
              v-text-field(label='標題 *' v-model='lottery.title' :rules='titleRules' autofocus)
              v-textarea(label='內容' v-model.trim='lottery.content' )
              DateTimePicker(:name='$t("start")' v-model='lottery.begin')
              DateTimePicker(:name='$t("end")' v-model='lottery.end')
              v-text-field(label='抽出人數 *' v-model.trim.number='lottery.numOfWinner' type='number' :rules='numOfWinnerRules')
              .mb-3
                v-subheader.pl-0 圖片
                ImageSelector(v-model='lottery.photo' :max='1000')

            v-flex(xs12 md6)
              v-switch(color='primary' v-model='lottery.isOpen' hide-details)
                template(slot='label') 是否開放使用者參加: #[strong {{ lottery.isOpen ? `已開放` : `未開放` }}]
              v-switch(color='primary' v-model='lottery.isShow' hide-details)
                template(slot='label') 是否顯示: #[strong {{ lottery.isShow ? `已顯示` : `已隱藏` }}]
              div(v-if='id')
                v-subheader.pl-0 參與者
                .pl-1(v-if='lottery.participant')
                  //- v-treeview(:items='participant' open-on-click)
                    v-icon(v-if='!item.children' slot='prepend' slot-scope='{ item }' small) fas fa-user
                  v-expansion-panel
                    v-expansion-panel-content
                      div(slot='header') 目前有 {{ lottery.participant.length }} 位參與者
                      v-card
                        v-card-text
                          ol: li(v-for='i in lottery.participant' :key='i'): span.line-id {{ i }}
                .pl-1(v-else) -

                v-subheader.pl-0 得獎者
                v-container.pa-0(grid-list-sm v-if='lottery.winner')
                  v-layout(row wrap)
                    v-flex(xs12 md6 v-for='(i, index) in lottery.winner' :key='index')
                      LotteryWinnerCard(:data='i')
                .pl-1(v-else) -
      DebugCodeBlock(:value='lottery')
    Loader(:show='lottery === null')
</template>

<script>
import apis from '@/assets/js/apis'

import { formStatus } from '@/mixins/formStatus'

import Loader from '@/components/Loader.vue'
import DateTimePicker from '@/components/DateTimePicker.vue'
import ImageSelector from '@/components/ImageSelector.vue'

import LotteryWinnerCard from '@/components/lottery/LotteryWinnerCard.vue'

export default {
  name: 'EditLottery',
  data () {
    return {
      id: null,
      period: null,
      lottery: null,
      titleRules: [
        v => !!v || 'Title is required',
      ],
      numOfWinnerRules: [
        v => !!v || 'The number of winner is required',
      ],
    }
  },
  methods: {
    // 初始化(編輯)
    init (params) {
      this.clearError()
      this.period = params.period
      this.id = params.id
      this.dialog = true
      this.isSaving = false
      this.imgBase64Size = null
      this.fetch()
    },
    // 初始化(新增抽獎)
    addNew (params) {
      this.clearError()
      this.period = params.period
      this.id = null
      this.dialog = true
      this.isSaving = false
      this.imgBase64Size = null

      // 初始化欄位
      this.lottery = {
        photo: null,
        period: this.period,
        begin: +new Date(),
        end: +new Date() + (1000 * 24 * 60 * 60 * 7),
        isOpen: true,
        isShow: true,
      };
      ['title', 'content'].forEach(v => { this.lottery[v] = '' })
    },
    async fetch () {
      const params = { lotteryId: this.id, period: this.period }
      this.lottery = null
      this.isModified = true
      try {
        this.lottery = await apis.lottery.get(params, this.token) || {}
        this.$nextTick(() => { this.isModified = false })
      } catch (e) {
        this.error = e
        this.lottery = false
      }
    },
    async save () {
      if (!this.valid || this.isSaving) return
      this.clearError()
      this.isSaving = true
      const body = { period: this.period, ...this.lottery }

      try {
        if (this.id) { // 若為保存
          body.id = this.id
          await apis.lottery.put(body, this.token)
          this.$emit('success')
        } else { // 若為新增
          await apis.lottery.post(body, this.token)
          this.$emit('success', 'add')
        }
        this.close()
      } catch (e) {
        this.isSaveFailed = true
        this.error = e
        this.isSaving = false
      }
    },
    remove () {
      if (!confirm('是否確認移除？')) return

      this.clearError()
      this.isSaving = true
      const body = { lotteryId: this.id, period: this.period }

      apis.lottery.remove(body, this.token)
        .then(() => {
          this.$emit('success', 'remove')
          this.close()
        })
        .catch((e) => {
          this.isSaveFailed = true
          this.error = e
          this.isSaving = false
        })
    },
    removeWinner () {
      if (this.isModified) {
        alert('有尚未發佈的變更！請先發佈或者捨棄變更再執行此操作')
        return
      }
      if (!confirm('是否確認清空得獎者名單？')) return

      this.clearError()
      this.isSaving = true
      const body = { lotteryId: this.id, period: this.period, ...this.lottery, winner: null }
      apis.lottery.put(body, this.token)
        .then(() => {
          this.$emit('success', 'removeWinner')
          this.fetch()
          this.isSaving = false
        })
        .catch((e) => {
          this.isSaveFailed = true
          this.error = e
          this.isSaving = false
        })
    },
  },
  computed: {
    isLoading () {
      return (this.isSaving || !this.lottery) && !this.error
    },
    dialogMaxWidth () {
      return 1200
    },
    isFullscreen () {
      return this.isMobile
    },
    transition () {
      return this.isFullscreen ? 'dialog-bottom-transition' : 'dialog-transition'
    },
    participant () {
      return [
        {
          name: `目前有 ${this.lottery.participant.length} 位參與者`,
          children: this.lottery.participant.map(v => { return { name: v } }),
        },
      ]
    },
  },
  watch: {
    lottery: {
      handler () {
        this.isModified = true
      },
      deep: true,
    },
  },
  components: {
    Loader,
    DateTimePicker,
    ImageSelector,
    LotteryWinnerCard,
  },
  mixins: [formStatus],
}
</script>

<style lang='sass'>
.line-id
  font-family: $monospace
</style>
